export const PAGE_VISIT_EVENT = 'page_visit';
export const PAGE_VIEW_EVENT = 'page_view';
export const TIME_SPENT_EVENT = 'time_spent';
export const FILTER_USED_EVENT = 'filter_used';
export const SLICER_INTERACTION = 'slicer_interaction';
export const FILTER_COMBINATION_EVENT = 'filter_combination_applied';
export const BREADCRUMB_EVENT = 'breadcrumb_navigation';
export const EXTERNAL_LINK_CLICK = 'external_link_click';
export const COUNTRY_NAVIGATION_EVENT = 'navigation_source';
export const SEARCH_PERFORMED = 'search_performed';
export const TRIAL_VIEWED = 'trial_viewed';
export const COUNTRY_VIEWED = 'country_viewed';
export const SITE_VIEWED = 'site_viewed';
export const PORTFOLIO_VIEWED = 'portfolio_viewed';
export const BOOKMARK_EVENT = 'bookmark_save_event';
export const DATA_SOURCE = 'data_source_event';
export const SAVE_FILTER = 'save_filter';
export const TOGGLE_CLICKED = 'toggle_clicked';
export const ANCHOR_EVENT = 'anchor_clicked';
export const CHART_INTERACTION = 'chart_interaction';
export const PAGINATION_INTERACTION = 'pagination_interaction';
export const CHAT_EVENT = {
  SEND_MESSAGE: 'chat_send_message',
  PROMPT_SELECT: 'chat_prompt_select',
  PROMPT_CATEGORY_SELECT: 'chat_prompt_category_select',
  PROMPT_TOGGLE: 'chat_prompt_toggle',
  MINIMIZE: 'chat_minimize',
  CLOSE: 'chat_close',
  EXPAND: 'chat_expand',
  COPY: 'chat_copy',
  GUIDELINES_CLICK: 'chat_guidelines_click',
};

export const CHAT_EVENT_ATTRIBUTES = {
  page_title: 'COMPASS - Chat',
  page_path: '/chat',
};
